//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio/Nicolas Pascucci
// Creation Date : 05/03/2024
// Version : 1
// Description : Pantalla de botones pa ra ver los pedidos
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/

import React, { useState, useEffect } from "react";
import "moment/locale/es";
import { Button } from "@mui/material";
import Navbar from "../Navbar";
import ButtonGroup from "@mui/material/ButtonGroup";
import PedidosNatural from "./PedidosNatural";
import PedidosHipergas from "./PedidosHipergas";
import { logEventos } from "../../services/services";

function PedidosProveedores() {
  const [showPedidosNatural, setShowPedidosNatural] = useState(true);
  const [showPedidosHipergas, setShowPedidosHipergas] = useState(false);

  useEffect(() => {
    logEventos(
      "Acceso al menú pedidos a petroleras",
      "Pedidos a Petroleras",
      "Hacer pedidos a NaturalGas o a Hipergas",
      localStorage.getItem("user")
    );
  }, []);

  const handleNatural = () => {
    setShowPedidosNatural(true);
    setShowPedidosHipergas(false);
    // console.log("Botón NATURALGAS presionado");
  };

  const handleHiper = () => {
    setShowPedidosHipergas(true);
    setShowPedidosNatural(false);
    //  console.log("Botón HIPERGAS presionado");
  };

  return (
    <>
      <Navbar />
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: 10,
          width: "100%",
        }}
      >
        <ButtonGroup
          disableElevation
          variant="contained"
          size="large"
          sx={{
            flexDirection: { xs: "column", sm: "row" }, // vertical en mobile, horizontal en desktop
            width: { xs: "90%", sm: "auto" },
            gap: 1, // espacio entre botones en mobile
          }}
        >
          <Button
            onClick={handleNatural}
            sx={{
              backgroundColor: "#7C297C",
              color: "white",
              borderRadius: 1,
              fontSize: { xs: 14, sm: 15 },
              paddingY: 1.5,
              "&:hover": { backgroundColor: "#6b256b" },
            }}
          >
            NATURALGAS
          </Button>
          <Button
            onClick={handleHiper}
            sx={{
              borderRadius: 1,
              fontSize: { xs: 14, sm: 15 },
              paddingY: 1.5,
            }}
          >
            HIPERGAS
          </Button>
        </ButtonGroup>
      </div>
      {showPedidosNatural && <PedidosNatural />}
      {showPedidosHipergas && <PedidosHipergas />}
    </>
  );
}

export default PedidosProveedores;
